export const getImageUrl = (id, index, sizeOption = 'md') => {
  const sizeOptions = {
    xs: '0x200',
    sm: '600x0',
    md: '800x0',
    lg: '900x0',
    xl: '1600x0'
  }

  const size = sizeOptions[sizeOption] ?? `${sizeOption}x0`

  return `${import.meta.env.VITE_IMAGES_URL}/image/${size}/${index}.webp`
}

export const formatSpec = (value, unit, lang = 'da') => {
  if (value == null) return '-'
  if (unit == null) unit = ''
  const stringValue = typeof value == 'number' ? value.toLocaleString(lang) : value
  return stringValue + ' ' + unit
}
